<template>
<div style="overflow-y: hidden;">
  <v-card v-if="languages === 'th'">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">
          <span class="headline CSChatThai">
            <v-icon color="white">assignment_ind</v-icon>&nbsp;&nbsp;เงื่อนไขและข้อตกลงการให้บริการ
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-card-text class="scrolling-wrapper CSChatThai" style="height: 80vh; margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
      <h2 style="text-align: center;text-decoration: underline;" class="CSChatThai">เงื่อนไขและข้อตกลงการให้บริการ
      </h2>
      <br><br>
      <div style="padding-left: 50px;">
        <strong>1.การใช้บริการของเรา</strong>
        <br>&nbsp;&nbsp;&nbsp;1.1 การใช้บริการของเราไม่ได้ทำให้คุณเป็นเจ้าของสิทธิในทรัพย์สินทางปัญญาใดๆ ในบริการหรือเนื้อหาที่คุณเข้าถึง
        <br>&nbsp;&nbsp;&nbsp;1.2 การใช้บริการจากเรา เราอาจส่งประกาศเกี่ยวกับบริการ ข่าวสารเกี่ยวกับการบริหารจัดการ และข้อมูลอื่นๆ ให้แก่คุณ คุณสามารถเลือกไม่รับการสื่อสารเหล่านี้บางรายการได้
        <br>&nbsp;&nbsp;&nbsp;1.3 บริการบางอย่างของเราสามารถใช้บนอุปกรณ์เคลื่อนทึ่ห้ามใช้บริการดังกล่าวในลักษณะที่ทำให้คุณเสียสมาธิและทำให้ไม่สามารถปฏิบัติตามกฎจราจรหรือกฎหมายด้านความปลอดภัย
        <br><br>
        <strong>2. บัญชี One Platform ของคุณ </strong>
        <br>&nbsp;&nbsp;&nbsp;2.1 คุณอาจต้องมีบัญชี One Platform เพื่อที่จะใช้บริการบางส่วนของเราอาจมีข้อกำหนดอื่นหรือเพิ่มเติมบังคับใช้กับคุณ และผู้ดูแลระบบของคุณอาจสามารถเข้าถึงหรือปิดการใช้งานบัญชีของคุณได้
        <br>&nbsp;&nbsp;&nbsp;2.2 เพื่อปกป้องบัญชี One Platform ของคุณ โปรดเก็บรักษารหัสผ่านเป็นความลับ คุณมีความรับผิดชอบต่อกิจกรรมที่เกิดขึ้นบนหรือผ่านบัญชี One Platform ของคุณ พยายามไม่ใช้รหัสผ่านบัญชี One Platform ซ้ำบนแอปพลิเคชันของบุคคลที่สาม
        <br><br>
        <strong>3. การคุ้มครองข้อมูลส่วนบุคคลและลิขสิทธิ์</strong>
        <br>&nbsp;&nbsp;&nbsp;3.1 เมื่อคุณใช้บริการของเรา ถือว่าคุณยินยอมให้ One Platform ใช้ข้อมูลดังกล่าวตามนโยบายส่วนบุคคลนั้น
        <br><br>
        <strong>4. การปรับเปลี่ยนและการยุติการให้บริการของเรา </strong>
        <br>&nbsp;&nbsp;&nbsp;4.1 เราทำการเปลี่ยนแปลงและปรับปรุงบริการของเราอย่างสม่ำเสมอ เราอาจเพิ่มหรือนำ <br>ระบบการทำงานหรือคุณลักษณะบางอย่างออก และเราอาจระงับหรือหยุดให้บริการใดบริการหนึ่งโดยสิ้นเชิง
        <br>&nbsp;&nbsp;&nbsp;4.2 คุณสามารถหยุดใช้บริการของเราได้ทุกเมื่อ
        <br><br>
        <strong>5. การใช้บริการของเราในทางธุรกิจ </strong>
        <br>&nbsp;&nbsp;&nbsp;5.1 หากคุณใช้บริการของเราในนามของธุรกิจ ธุรกิจนั้นจะต้องยอมรับข้อกำหนดเหล่านี้
        <br>&nbsp;&nbsp;&nbsp;5.2 ธุรกิจจะไม่เรียกร้องให้ One Platform และบริษัทในเครือ เจ้าหน้าที่ ตัวแทน และพนักงานของ One Platform ชดใช้ค่าเสียหายให้แก่คุณ
        และคุณจะไม่ฟ้องร้องคดีหรือดำเนินการใดๆอันเกิดจากหรือเกี่ยวกับการใช้บริการหรือการละเมิดข้อกำหนดเหล่านี้รวมถึงไม่ให้บุคคลดังกล่าวมีความรับผิดหรือต้องชำระค่าใช้จ่ายใดๆ ที่เกิดจากการเรียกร้องค่าสินไหมทดแทน การสูญเสีย ความเสียหาย การฟ้องร้องคดี
        การตัดสินคดี ค่าใช้จ่ายในการดำเนินคดี และค่าทนายความ <br>
      </div>
    </v-card-text>
  </v-card>
  <v-card v-else>
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">
          <span class="headline CSChatThai">
            <v-icon color="white">assignment_ind</v-icon>&nbsp;&nbsp;Terms and Conditions of Service
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-card-text class="scrolling-wrapper CSChatThai" style="height: 80vh; margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
      <h2 style="text-align: center;text-decoration: underline;" class="CSChatThai">Terms and Conditions of Service
      </h2>
      <br><br>
      <div style="padding-left: 50px;">
        <strong>1. Using of our services</strong>
        <br>&nbsp;&nbsp;&nbsp;1.1 Your using of our services does not give you ownership of any intellectual property rights in the services or content you access.
        <br>&nbsp;&nbsp;&nbsp;1.2 By providing services from us, we may send service announcements; provide you with administrative news and other information to you.  You can opt-out of some of these communications.
        <br>&nbsp;&nbsp;&nbsp;1.3 Some of our services can be used on mobile devices so do not use them in a way that distracts  and prevents you from complying with traffic or safety laws.
        <br><br>
        <strong>2. Your One Platform account</strong>
        <br>&nbsp;&nbsp;&nbsp;2.1 You may need a One Platform account in order to use some of our services, other or additional terms may apply to you and your administrator may be able to access or disable your account.
        <br>&nbsp;&nbsp;&nbsp;2.2 To protect your One Platform account, please keep your password confidential. You are responsible for any activities that occur on through your One Platform account. Try not to reuse your One Platform account password on any third-party applications.
        <br><br>
        <strong>3. Protection of personal data and copyright</strong>
        <br>&nbsp;&nbsp;&nbsp;3.1 By using our services, you consent to the use of such information by One Platform in accordance with that Privacy Policy.
        <br><br>
        <strong>4. Modifications and Terminations of our Services</strong>
        <br>&nbsp;&nbsp;&nbsp;4.1 We make changes and improvements to our services regularly, we may add or remove certain functionality or features and we may suspend or discontinue any service altogether.
        <br>&nbsp;&nbsp;&nbsp;4.2 You can stop using our services at any time.
        <br><br>
        <strong>5. Business use of our services</strong>
        <br>&nbsp;&nbsp;&nbsp;5.1 If you use our services on behalf of a business, that business must agree to these terms.
        <br>&nbsp;&nbsp;&nbsp;5.2 The business will not demand that One Platform and its affiliates, officers, agents and employees indemnify to you and you will not litigate or take action arising out of or in connection with your use of the service or breach of these terms including that such person shall not be liable or have to pay any expenses arising from claims, losses, damages, litigation, judgments, litigation costs and attorney fees.
        <br>
      </div>
    </v-card-text>
  </v-card>
</div>
</template>
<script type="text/javascript">
  export default {
    data () {
      return {
        languages: ''
      }
    },
    watch: {
      '$i18n.locale' () {
        this.languages = this.$i18n.locale
      }
    },
    created () {
      this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
      this.languages = this.$i18n.locale
      console.log(this.languages)
    }
  }
</script>

<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}

.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/settings/terms_of_service.vue